export enum Draggables {
    ONLY_DROPPABLE_ON_REPORT_PAPER = 'onlyDroppableOnReportPaper',
}



// WEBPACK FOOTER //
// ./src/beautiful-dnd/Draggable.ts